<!--
 * @Descripttion:字典目录表页面
 * @version: 1.0.0
 * @Author: T.s
 * @Date: 2021-01-12 11:13:22
 * @LastEditors: T.s
 * @LastEditTime: 2021-01-12 11:13:22
 -->
<template>
  <basicContainer style="margin-left: 5px;">
    <el-dialog
      width="75%"
      top="5vh"
      :append-to-body="true"
      :visible.sync="cataManage.isShow"
      @close="closeOpen"
    >
      <div class="easyCruds_head">
        <i class="fa fa-table easyCruds_head_icon" style="color:#409EFF"></i>
        <span class="easyCruds_head_title" style="color:#409EFF">&nbsp;字典目录表</span>
      </div>
      <div class="el-card__body">
        <avue-crud
          :option="option"
          :data="data"
          :table-loading="loading"
          :page="page"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-save="rowSave"
          @row-update="rowUpdate"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @size-change="sizeChange"
          @current-change="currentChange"
          @selection-change="selectionChange"
        >
          <!-- 操作按钮扩展 -->
          <template slot="menuLeft">
            <el-button type="danger" size="small" icon="el-icon-delete" @click="delAll">删 除</el-button>
          </template>
          <!-- 操作列改变状态按钮扩展 -->
          <template slot-scope="{row}" slot="menu">
            <el-button
              icon="el-icon-close"
              size="small"
              type="text"
              @click="disable(row)"
              v-if="row.status === 1"
            >禁用</el-button>
            <el-button icon="el-icon-check" size="small" type="text" @click="enable(row)" v-else>启用</el-button>
          </template>
        </avue-crud>
      </div>
    </el-dialog>
  </basicContainer>
</template>

<script>
export default {
  props: ['cataManage'],
  data() {
    return {
      v_timeWindow: [],
      loading: true,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      searchkey: null,
      delDataList: [],
      data: [],
      option: {
        title: '字典目录表',
        dialogWidth: 1000,
        dialogHeight: 400,
        height: 450,
        align: 'center',
        tip: true,
        stripe: true,
        border: true,
        index: false,
        viewBtn: false,
        dialogClickModal: false,
        delBtn: false,
        selection: true,
        column: [
          {
            label: '目录码',
            prop: 'cataCode',
            span: 12,
            search: true,
            rules: [{
              required: true,
              message: '请输入目录码',
              trigger: 'blur'
            }]
          },
          {
            label: '目录名',
            prop: 'cataName',
            span: 12,
            search: true,
            rules: [{
              required: true,
              message: '请输入目录名',
              trigger: 'blur'
            }]
          },
          {
            label: '目录排序',
            prop: 'cataSort',
            type: 'number',
            span: 12,
            rules: [{
              required: true,
              message: '请输入目录排序',
              trigger: 'blur'
            }]
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            // slot: true,
            dicData: [
              /** {
                label: '启用',
                value: '1'
              },
              {
                label: '禁用',
                value: '2'
              }**/
              {
                label: '启用',
                value: 1
              },
              {
                label: '禁用',
                value: 2
              }
            ],
            span: 12,
            // labelWidth: 120,
            rules: [{
              required: true,
              message: '请输入状态',
              trigger: 'blur'
            }]
          },
          {
            label: '创建人',
            prop: 'creatorId',
            span: 12,
            hide: true,
            display: false,
            rules: [{
              required: false,
              message: '请输入创建人',
              trigger: 'blur'
            }]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            span: 12,
            hide: true,
            display: false,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            view: [false, false, true],
            disabled: [false, false, true],
            width: 150,
            rules: [{
              required: false,
              message: '请输入创建时间',
              trigger: 'blur'
            }]
          },
          {
            label: '更新人',
            prop: 'updatorId',
            span: 12,
            hide: true,
            display: false,
            rules: [{
              required: false,
              message: '请输入更新人',
              trigger: 'blur'
            }]
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            span: 12,
            hide: true,
            display: false,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            view: [false, false, true],
            disabled: [false, false, true],
            width: 150,
            rules: [{
              required: false,
              message: '请输入更新时间',
              trigger: 'blur'
            }]
          }
          // {
          //   label: '规则组编号',
          //   prop: 'ruleGroupId',
          //   type: 'select',
          //   // 下拉转换
          //   dicData: [],
          //   //后台取不规则下拉数据时，解析匹配label和value的配置
          //   props:
          //   {
          //     label: 'groupName',
          //     value: 'id'
          //   },
          //   search: true
          // },
          // 字段为varchar类型时用这种下拉
          // {
          //   label: 'http方法',
          //   prop: 'httpMothed',
          //   search: false,
          //   labelWidth: 120,
          //   type: 'select',
          //   dicUrl: '/pub/dm-const/listByCataCode?filterStatus=true&cataCode=http_method',
          //   dicMethod: 'get',
          //   props: {
          //     label: 'label',
          //     value: 'value'
          //   },
          //   rules: [{
          //     required: true,
          //     message: '请输入http方法',
          //     trigger: 'blur'
          //   }]
          // }
        ]
      }
    }
  },
  mounted() {
    this.allDropdown()
    this.onLoad()
  },
  methods: {
    // 关闭时的回调
    beforeClose() {
    },
    closeOpen() {
      this.$emit('noticeParent')
    },
    // 获取字典下拉
    getOptionsByCataCode(_columnSort, _cataCode) {
      let getUrl = `/pub/dm-const/listByCataCode?cataCode=${_cataCode}`
      getUrl += `&filterStatus=true`

      this.$http.get(getUrl)
        .then(res => {
          var dataList = res.data
          const map = dataList.map(x => {
            if (typeof x.value === 'string') {
              x.value = Number(x.value)
              return x
            }
          })
          var newList = dataList.filter((item) => {
            return item.value = Number(item.value)
          })
          this.option.column[_columnSort].dicData = res.data
        }).catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 获取关联下拉
    getOptions(_columnSort, _url) {
      this.$http.get(`${_url}`)
        .then(res => {
          this.option.column[_columnSort].dicData = res.data
        }).catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 系统下拉汇
    allDropdown() {
      // 获取字典下拉
      // this.getOptionsByCataCode(2, 'ruleType')
      // 获取关联下拉
      // this.getOptions(3, `/dqm/rule-group`)
    },
    // 打开弹框之前
    beforeOpen(done, type) {
      console.log(done)
      // this.allDropdown()
      this.getOptionsByCataCode(2, 'ruleType')
      done()
    },
    // 新增保存
    rowSave(row, done, loading) {
      console.log(row)
      console.log(done)

      // delete row.$status
      this.$http.post('/pub/dm-const-cata', row).then(res => {
        // this.data.splice(0, 0, row)
        this.$message.success('新增成功') && loading()
        done()
        this.onLoad('', '', this.searchkey)
      })
        .catch(error => {
          this.$message.error(error.msg) && done()
          this.$Log.capsule('字典目录表新增 -失败', error, 'danger')
        })
    },
    // 编辑更新
    rowUpdate(row, index, done, errorDone, loading) {
      this.$http.put('/pub/dm-const-cata', row).then(res => {
        this.$message.success('修改成功')
        this.onLoad('', '', this.searchkey)
        done()

        this.$emit('noticeParent')
      })
        .catch(error => {
          this.$message.error(error.msg) && errorDone()
          this.$Log.capsule('字典目录表更新 -失败', error, 'danger')
        })
    },
    // 删除数据
    deleteData(data) {
      if (data.length > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.delete('/pub/dm-const-cata', {
            params: {
              idList: data
            }
          }).then(res => {
            this.onLoad('', '', this.searchkey)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }).catch(error => {
            this.$message.error(error.msg) && errorDone()
            this.$Log.capsule('字典目录表删除 -失败', error, 'danger')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.$message({
          type: 'warning',
          message: '未选择删除数据!'
        })
      }
    },
    // 单行删除
    rowDel(row, index) {
      this.delDataList[0] = row.id
      this.deleteData(this.delDataList)
    },
    // 多条删除
    delAll() {
      this.deleteData(this.delDataList)
    },
    // 搜索查询
    searchChange(params, done) {
      params.startDate = this.v_timeWindow[0]
      params.endDate = this.v_timeWindow[1]
      this.searchkey = params
      typeof done === 'function' && done()
      this.onLoad(1, '', params)
    },
    // 搜索清空按钮事件
    searchReset() {
      this.searchForm = {}
      this.v_timeWindow = ''
    },
    // 启用数据
    enable(row) {
      this.datause(row, '启用', '1')
    },
    // 禁用数据
    disable(row) {
      this.datause(row, '禁用', '2')
    },
    // 常量启用禁用
    datause(row, tip, status) {
      this.$confirm('是否' + tip + '该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.put('/pub/dm-const-cata/updateStatus?id=' + row.id + '&status=' + status, {
        }, { emulateJSON: true }).then(res => {
          row.status = status
          this.onLoad('', '', this.searchkey)
          this.$message({
            type: 'success',
            message: tip + '成功!'
          })
        }).catch(error => {
          this.$message.error(error.msg)
          this.$Log.capsule(tip + '- 失败', error, 'danger')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消' + tip
        })
      })
    },
    // 选择每页展示条数
    sizeChange(val) {
      this.onLoad('', val, this.searchkey)
    },
    // 翻页
    currentChange(val) {
      this.onLoad(val, '', this.searchkey)
    },
    // 分页查询
    onLoad(pageNum, pageSize, params) {
      this.loading = true
      if (pageNum) this.page.currentPage = pageNum
      if (pageSize) this.page.pageSize = pageSize
      params = params || null
      let fenye = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      this.$http.get('/pub/dm-const-cata/query', {
        params: Object.assign(fenye, params)
      }).then(res => {
        this.loading = false
        this.data = res.data.records
        this.page.total = res.data.total || res.data.records.length
      }).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    // 多选
    selectionChange(list) {
      //  删除多条数据
      let newlist = list.map(e => {
        return e.id
      })
      this.delDataList = newlist
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
